'use strict';
var uniqueId;

require('../../../core/frontend/groupon_modules/groupon');

uniqueId = require('../../../src/frontend/helper/general/m_underscore_replacements').uniqueId;

Groupon.Keymap = {
  'TAB': 9,
  'ENTER': 13,
  'ESCAPE': 27,
  'SPACE': 32,
  'END': 35,
  'HOME': 36,
  'LEFT': 37,
  'UP': 38,
  'RIGHT': 39,
  'DOWN': 40,
  'DELETE': 46
};

window.Groupon.AriaMenuNavigation = (function() {
  function AriaMenuNavigation() {}

  AriaMenuNavigation.prototype.initMenuNavigation = function($menuTrigger, $menu, $menuLinks, menuTriggerParent) {
    this.$menuTrigger = $menuTrigger;
    this.$menu = $menu;
    this.$menuLinks = $menuLinks;
    this.initAriaAttributes($menuTrigger, $menu, $menuLinks, menuTriggerParent);
    return this.bindMenu();
  };

  AriaMenuNavigation.prototype.initAriaAttributes = function($menuTrigger, $menu, $menuLinks, menuTriggerParent) {
    var $triggerWrapper, menuExists, menuID;
    if ($menu.length) {
      menuExists = true;
      if (!$menu[0].id) {
        $menu[0].id = uniqueId('sls-aria-');
      }
      menuID = $menu[0].id;
    }
    if (!$menuTrigger[0].id) {
      $menuTrigger[0].id = uniqueId('sls-aria-');
    }
    $menuTrigger.attr({
      'role': 'menuitem',
      'aria-haspopup': menuExists,
      'aria-owns': menuID,
      'tabindex': '0'
    });
    $triggerWrapper = this.ariaFindClosestParent($menuTrigger, menuTriggerParent);
    $triggerWrapper.attr({
      'role': 'menubar'
    });
    if (!menuExists) {
      return;
    }
    $menu.attr({
      'role': 'menu',
      'aria-hidden': 'true',
      'aria-labelledby': $menuTrigger[0].id
    });
    if (!$menuLinks.length) {
      $menu.attr('role', null);
    }
    return $menuLinks.attr({
      'tabindex': '-1',
      'role': 'menuitem'
    });
  };

  AriaMenuNavigation.prototype.ariaFindClosestParent = function($source, selector) {
    var $parent;
    if (selector == null) {
      selector = '';
    }
    if (!selector) {
      if ($source.parent()[0].nodeName === 'LI') {
        selector = 'ul';
      } else {
        selector = 'nav';
      }
    }
    $parent = $source.closest(selector);
    return $parent = $parent.length ? $parent : $source.closest('div');
  };

  AriaMenuNavigation.prototype.bindMenu = function() {
    this.ariaBindMenuTrigger(this.$menuTrigger);
    return this.ariaBindMenuLinks();
  };

  AriaMenuNavigation.prototype.ariaBindMenuTrigger = function($trigger) {
    if ($trigger == null) {
      $trigger = this.$menuTrigger;
    }
    $trigger.off('keydown');
    return $trigger.on('keydown', (function(_this) {
      return function(e) {
        var DOWN, SPACE, ref, ref1;
        ref = Groupon.Keymap, SPACE = ref.SPACE, DOWN = ref.DOWN;
        if ((ref1 = e.keyCode) === SPACE || ref1 === DOWN) {
          _this.$menu.attr('aria-hidden', 'false').show();
          return _this.$menuLinks.eq(0).focus().attr('tabindex', 0);
        }
      };
    })(this));
  };

  AriaMenuNavigation.prototype.ariaBindMenuLinks = function() {
    this.$menuLinks.off('keydown');
    return this.$menuLinks.on('keydown', (function(_this) {
      return function(e) {
        var DOWN, ESCAPE, TAB, UP, keycode, linkIndex, ref;
        keycode = e.keyCode;
        ref = Groupon.Keymap, UP = ref.UP, DOWN = ref.DOWN, ESCAPE = ref.ESCAPE, TAB = ref.TAB;
        if (keycode === ESCAPE || keycode === TAB) {
          e.keyCode = ESCAPE;
          return _this.ariaCloseMenu(_this.$menuTrigger);
        } else {
          linkIndex = $.inArray(e.currentTarget, _this.$menuLinks);
          if (keycode === UP) {
            if (linkIndex === 0) {
              _this.ariaResetIndex(linkIndex);
              _this.ariaBrowseLinks(_this.$menuLinks.length - 1, 0);
            } else {
              _this.ariaBrowseLinks(linkIndex, -1);
            }
          }
          if (keycode === DOWN) {
            if (linkIndex === _this.$menuLinks.length - 1) {
              _this.ariaResetIndex(linkIndex);
              return _this.ariaBrowseLinks(0, 0);
            } else {
              return _this.ariaBrowseLinks(linkIndex, 1);
            }
          }
        }
      };
    })(this));
  };

  AriaMenuNavigation.prototype.ariaBrowseLinks = function(i, sibling) {
    this.ariaResetIndex(i);
    return this.$menuLinks.eq(i + sibling).focus().attr('tabindex', '0');
  };

  AriaMenuNavigation.prototype.ariaResetIndex = function(i) {
    return this.$menuLinks.eq(i).attr('tabindex', '-1');
  };

  AriaMenuNavigation.prototype.ariaCloseMenu = function($trigger) {
    if ($trigger == null) {
      $trigger = this.$menuTrigger;
    }
    this.$menu.attr('aria-hidden', 'true').hide();
    this.$menuLinks.attr('tabindex', '-1');
    return $trigger.focus();
  };

  return AriaMenuNavigation;

})();

